import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { SelfTriageCounselingRequest } from '../../requests/self-triage/self-triage-counseling.request';
import { GetSelfTriageCounselingResponse } from '../../responses/self-triage/get-counseling-self-triage.response';
import { ListSelfTriageCounselingResponse } from '../../responses/self-triage/list-counseling-self-triage.response';

@Injectable({
  providedIn: 'root'
})
export class SelfTriageCounselingService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  listCounseling(searchText: string): Observable<ListSelfTriageCounselingResponse> {
    let uri = `SelfTriageCounseling?`
    if (searchText) {
      uri = uri + `searchText=${searchText}`
    }

    return this.httpClient.get<ListSelfTriageCounselingResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  getCounseling(idSelfTriageCounseling: number): Observable<GetSelfTriageCounselingResponse> {
    let uri = `SelfTriageCounseling/idSelfTriageCounseling/${idSelfTriageCounseling}`

    return this.httpClient.get<GetSelfTriageCounselingResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  postCounseling(body: SelfTriageCounselingRequest): Observable<ReturnStruct> {
    let uri = `SelfTriageCounseling`

    return this.httpClient.post<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, body, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  updateCounseling(idSelfTriageCounseling: number, body: SelfTriageCounselingRequest): Observable<ReturnStruct> {
    let uri = `SelfTriageCounseling/idSelfTriageCounseling/${idSelfTriageCounseling}`

    return this.httpClient.put<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, body, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  deleteCounseling(idSelfTriageCounseling: number): Observable<ReturnStruct> {
    let uri = `SelfTriageCounseling/idSelfTriageCounseling/${idSelfTriageCounseling}`

    return this.httpClient.delete<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}